export default __webpack_public_path__ + "static/media/Non-Sale Stock Management.12ab8174.png";